export const global = {
    // BASE_URL: 'http://62.234.140.214:8088/wx',
    // BASE_URL: 'http://192.168.0.146:8088/wx',
    BASE_URL: 'https://www.ccsht.cn:8877/wx',
    RESOURCE_PREFIX: 'https://www.ccsht.cn/resources/static'
};
